module.exports = __webpack_public_path__ + "img/horizontal_3_4_pp2_8003.8ebd6c1d.png";